/**
 * Service worker registration.
 *
 * Registered after `load` rather than during it, so fetching and installing the
 * worker never competes with the resources needed for first paint. The builder's
 * LCP was hard-won (4104ms to 1448ms); a service worker that costs any of it
 * back would be a poor trade.
 *
 * Deliberately silent about failure. A registration error means the user simply
 * has no offline support — every feature still works, so surfacing a warning
 * would be noise about something they cannot act on.
 */

export const registerServiceWorker = (): void => {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  // Dev serves modules from source with no built sw.js, and registering a stale
  // worker there is a reliable way to spend an afternoon debugging phantom caches.
  if (import.meta.env.DEV) return

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* No offline support this session. Everything else is unaffected. */
    })
  })
}
